import { NewsItemView } from "@/views/Clients/News/NewsItemView";
import { NewsListView } from "@/views/Clients/News/NewsListView";
import { PublicNewsItemView } from "@/views/Clients/News/PublicNewsItemView";
import { PublicNewsListView } from "@/views/Clients/News/PublicNewsListView";

import { ClientPage, PublicClientPage } from "./ClientPage";
import { ClientNewsPage, PublicClientNewsPage } from "./News";

export const pages = {
  client: ClientPage,
  "public-client": PublicClientPage,
  "client.news-detail": ClientNewsPage,
  "public-client.news-detail": PublicClientNewsPage,
  news: NewsListView,
  "public-news": PublicNewsListView,
  "news.news-detail": NewsItemView,
  "public-news.news-detail": PublicNewsItemView,
};
